/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-18T11:02:58-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-01T15:04:20-08:00
*/



import React, { Component } from 'react';

import ManagePrivacy from './ManagePrivacy';
import BlockedList from './BlockedList';
import Container from '../../blocks/Container';


class Privacy extends Component {
  render() {
    return (
      <div>
        <Container fullWidth>
          <ManagePrivacy updateAccountSetting={this.props.updateAccountSetting}
            settings={this.props.settings} />
          <BlockedList />
        </Container>

      </div>
    );
  }
}

export default Privacy;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/Privacy.jsx